import {
  ApiBaseService,
  IntegrationsServiceAPI,
} from '@/services/api.base.service';
import store from '@/store/store';
import { Integration, ManagementIntegrationConfiguration, SuccessResponse } from '@/types';

export class DeviceManagementService {
  private publish: ApiBaseService;

  constructor() {
    this.publish = IntegrationsServiceAPI;
  }

  public async getIntegrationsForDeviceManagement(): Promise<ManagementIntegrationConfiguration[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.publish.get(`organisation/${organisationId}/managementIntegrations`);
  }

  public async deleteIntegrationForDeviceManagement(integrationId: number): Promise<SuccessResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.publish.delete(`organisation/${organisationId}/managementIntegrations/${integrationId}`);
  }

  public async setDeviceManagementIntegration(
    integrationId: number,
    body: any,
  ): Promise<ManagementIntegrationConfiguration> {
    const organisationId = store.getters.activeOrganisation[0].id;
    body.integration_id = integrationId;
    return this.publish.post(`organisation/${organisationId}/managementIntegrations/`, body);
  }

  public async updateDeviceManagementIntegration(integrationConfigurationId: number, body: any): Promise<ManagementIntegrationConfiguration> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.publish.put(`organisation/${organisationId}/managementIntegrations/${integrationConfigurationId}`, body);
  }
}

export default new DeviceManagementService();
